import { Button } from "@/components/ui/button"
import { getTranslations } from "../../i18n"
import { useLocale } from "../../locale-context"
import { useProjectDetailContext } from "./project-detail-context"

/** Project members management — its own sub-tab (ZPL-126). */
export function ProjectMembersTab() {
	const {
		project: p,
		canManageMembers,
		archived,
		onRemoveMember,
		removeMemberPending,
		onOpenAddMember,
		runAction,
	} = useProjectDetailContext()
	const { locale } = useLocale()
	const t = getTranslations(locale)

	return (
		<section className="rounded-xl border border-border bg-card p-4 md:p-5">
			<div className="flex items-center justify-between gap-3">
				<h2 className="text-base font-bold text-foreground">
					{t.projects.detail.membersHeading}
				</h2>
				{canManageMembers && !archived ? (
					<Button variant="ghost" size="sm" onClick={onOpenAddMember}>
						{t.projects.detail.addMemberCta}
					</Button>
				) : null}
			</div>
			<ul className="mt-3 space-y-1">
				{(p.members ?? []).map((m) => {
					const full = [m.firstName, m.lastName].filter(Boolean).join(" ")
					return (
						<li
							key={m.id}
							className="flex items-center justify-between gap-3 px-3 py-2.5 rounded-xl border border-border bg-muted/40"
						>
							<div className="min-w-0">
								<span className="text-sm text-foreground/80 font-medium break-words">
									{full.length > 0 ? full : m.email}
								</span>
								<span className="block text-xs text-muted-foreground/80 truncate">
									{m.email}
								</span>
							</div>
							{canManageMembers && !archived ? (
								<button
									type="button"
									onClick={() => runAction(onRemoveMember(m.id))}
									disabled={removeMemberPending}
									className="text-xs text-destructive hover:text-destructive/80 transition-colors disabled:opacity-50 shrink-0"
								>
									{t.projects.detail.removeMemberLabel}
								</button>
							) : null}
						</li>
					)
				})}
			</ul>
		</section>
	)
}
